$(function() {
  let searchParams = new URLSearchParams(window.location.search);
  const form_trigger = searchParams.get('trigger-form');
  const article_number = searchParams.get('artikelnummer');
  const article_name = searchParams.get('artikelname');
  const referrer = searchParams.get('referrer');

  if (form_trigger === 'contact' && article_number) {
    $(window).trigger('formModal:openModal', {
      'url': '/contact/product-request/',
      'redirect_url': 'https://shop.teojakob.ch' + referrer,
      'form_data': {
        'product_id': article_number,
        'product_name': article_name,
        'path': referrer
      }
    });
  } else if (form_trigger === 'contact') {
    const $request_tag = $('[href="/contact/appointment/"]');
    if ($request_tag.length) {
      $($request_tag[0]).trigger('click');
    }
  } else if (form_trigger === 'magazine') {
    const $request_tag = $('[href="/contact/request-catalog/"]');
    if ($request_tag.length) {
      $($request_tag[0]).trigger('click');
    }
  }
});



// WEBPACK FOOTER //
// ./static/js/modules/form_modal_trigger.js